import { isContentOnly } from "utils/appMode";

const root = isContentOnly ? "" : "/create-content";

export const CataloguePath = {
  Exercises: `${root}/exercises`,
  Exercises_Changes: `${root}/exercises/:name/changes/:group`,
  Templates: `${root}/templates`,
  Templates_New: `${root}/templates/new`,
  Templates_Edit: `${root}/templates/:id/edit`,
  Templates_Changes: `${root}/templates/:name/changes/:group`,
  Lessons: `${root}/lessons`,
  Lessons_New: `${root}/lessons/new`,
  Lessons_Edit: `${root}/lessons/:id/edit`,
  Lessons_Changes: `${root}/lessons/:name/changes/:group`,
};
